<template></template>

<script>
    export default {
        name: "ReInitBaseComponent",
        props: {
            order: {id: Number, properties: [{typeId: Number, value: String}]},
            paymentIds: Array,
            label: String
        },
        mounted() {
            this.currentOrder = this.order;
            document.addEventListener('historyPaymentMethodChanged', (e) => {
                this.currentOrder = e.detail.newOrder.order;
            });
        },
        computed: {
            isVisible() {
                if (!this.currentOrder) {
                    console.log('this.order is empty');
                    return false;
                }
                let orderPaymentId = -1;
                let paidStatus = '';

                for (let property of this.currentOrder.properties) {
                    if (property.typeId === 3) {
                        orderPaymentId = parseInt(property.value);
                    }
                }

                for (let property of this.currentOrder.properties) {
                    if (property.typeId === 4) {
                        paidStatus = property.value.toString();
                    }
                }

                return this.paymentIds.indexOf(orderPaymentId) !== -1 && !(paidStatus === 'fullyPaid' || paidStatus === 'fullPaid');
            }
        },
        data() {
            return {
                failed: false,
                isActive: false,
                isLoading: false,
                currentOrder: {id: Number, properties: [{typeId: Number, value: String}]},
            }
        },
        methods: {
            prepareCheckout() {
                this.isLoading = true;
                this.failed = false;
                $.get('/rest/mollie/init_payment', {orderId: this.currentOrder.id})
                    .done((response) => {
                        if (response.error) {
                            this.failed = true;
                        } else if (response._links.checkout && response._links.checkout.href) {
                            window.location = response._links.checkout.href;
                        } else {
                            this.failed = true;
                        }
                    })
                    .fail((jqXHR) => {
                        this.failed = true;
                    })
                    .always(() => {
                        this.isLoading = false;
                    });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ReInitBaseComponent.vue